// extracted by mini-css-extract-plugin
export var alertIcon = "_ps-0";